export default "__VITE_ASSET__CqAdzimj__"